import { api } from '@services/api';

import { PaginationProps, PaginationReturn } from '@common/types/service';
import { IInbox } from '@inbox/types';

interface GetAllInboxesParams extends PaginationProps {
    search?: string;
    [key: string]: unknown;
}

const inboxApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getAllInboxes: builder.query<PaginationReturn<IInbox>, GetAllInboxesParams>({
            query: (params) => ({
                url: 'sales-inboxes/',
                params,
            }),
            providesTags: ['Inbox'],
        }),
        addInbox: builder.mutation<IInbox, Partial<IInbox>>({
            query: (inboxData) => ({
                url: 'sales-inboxes/',
                method: 'POST',
                body: inboxData,
            }),
            invalidatesTags: ['Inbox'],
        }),
        deleteInbox: builder.mutation<void, number[]>({
            query: (inboxIds) => ({
                url: `sales-inboxes/`,
                method: 'DELETE',
                body: { ids: inboxIds },
            }),
            invalidatesTags: ['Inbox'],
        }),
        updateInbox: builder.mutation<IInbox, { id: number; inboxData: Partial<IInbox> }>({
            query: ({ id, inboxData }) => ({
                url: `sales-inboxes/${id}/`,
                method: 'PUT',
                body: inboxData,
            }),
            invalidatesTags: ['Inbox'],
        }),
        activateInbox: builder.mutation<IInbox, { id: number }>({
            query: ({ id }) => ({
                url: `sales-inboxes/${id}/activate/`,
                method: 'PATCH',
            }),
            invalidatesTags: ['Inbox'],
        }),
        deactivateInbox: builder.mutation<IInbox, { id: number }>({
            query: ({ id }) => ({
                url: `sales-inboxes/${id}/deactivate/`,
                method: 'PATCH',
            }),
            invalidatesTags: ['Inbox'],
        }),
        bulkActivateInbox: builder.mutation<IInbox[], { ids: number[] }>({
            query: ({ ids }) => ({
                url: `sales-inboxes/activate/`,
                method: 'PATCH',
                body: { ids },
            }),
            invalidatesTags: ['Inbox'],
        }),
        bulkDeactivateInbox: builder.mutation<IInbox[], { ids: number[] }>({
            query: ({ ids }) => ({
                url: `sales-inboxes/deactivate/`,
                method: 'PATCH',
                body: { ids },
            }),
            invalidatesTags: ['Inbox'],
        }),
    }),
});

export const {
    useGetAllInboxesQuery,
    useAddInboxMutation,
    useDeleteInboxMutation,
    useUpdateInboxMutation,
    useActivateInboxMutation,
    useDeactivateInboxMutation,
    useBulkActivateInboxMutation,
    useBulkDeactivateInboxMutation,
} = inboxApi;
